import { ComponentProps } from 'react';

import { Bounce, FlexAligner, LoadingBubbles } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { Z_INDEX } from '@/constants';
import { colors } from '@/utils';

type LoadingSize = ComponentProps<typeof LoadingBubbles>['size'];

type LoaderProps = {
  render?: boolean;
  size?: LoadingSize;
  borderRadius?: string;
  loadingZIndex?: number;
  backgroundColor?: string;
  variant?: 'bounce' | 'bubbles';
  showWaitCursor?: boolean;
};
export const Loader = ({
  render = true,
  size = 'large',
  borderRadius = '0',
  backgroundColor = colors.background.neutral.soft[200],
  loadingZIndex = Z_INDEX.overlay.loading,
  variant = 'bubbles',
  showWaitCursor,
}: LoaderProps) => {
  if (!render) return <></>;
  return (
    <StyledLoading
      alignment='center'
      fullHeight={true}
      $backgroundColor={backgroundColor}
      $borderRadius={borderRadius}
      $loadingZIndex={loadingZIndex}
      $showWaitCursor={showWaitCursor}
    >
      {variant === 'bounce' ? <Bounce /> : <LoadingBubbles size={size} />}
    </StyledLoading>
  );
};

const StyledLoading = styled(FlexAligner)<{
  $loadingZIndex: number;
  $borderRadius: string;
  $backgroundColor?: string;
  $showWaitCursor?: boolean;
}>`
  z-index: ${({ $loadingZIndex }) => $loadingZIndex};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  position: absolute;
  opacity: 0.8;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? $backgroundColor : colors.background.neutral.soft[200]};
  inset: 0;
  flex: 1;

  cursor: ${({ $showWaitCursor }) => ($showWaitCursor ? 'wait' : 'inherit')};
`;
